export const LANGUAGES = {
    ENGLISH: 'en',
    KOREAN: 'ko',
    VIETNAMESE: 'vi',
};

export const LANGUAGE_CODES = {
    ENGLISH: "US",
    KOREAN: "KR",
    VIETNAMESE: "VN",
};